document.addEventListener('DOMContentLoaded', () => {
	const section = document.querySelector('.oa-location-explorer');
	if (!section) return;

	function activateSpace(spaceEl, locationId) {
		const locationEl = spaceEl.closest('.location');

		locationEl.querySelectorAll('.space').forEach(s => s.classList.remove('active'));
		spaceEl.classList.add('active');

		const spaceId = spaceEl.dataset.spaceId;

		section.querySelectorAll('.space-gallery').forEach(g => g.classList.remove('active'));
		const gallery = section.querySelector(`.space-gallery[data-space-id="${spaceId}"][data-location-id="${locationId}"]`);
		if (gallery) gallery.classList.add('active');
	}

	function activateLocation(locationEl) {
		section.querySelectorAll('.location').forEach(l => l.classList.remove('active'));
		locationEl.classList.add('active');

		const locationId = locationEl.dataset.locationId;

		section.querySelectorAll('.icon-container').forEach(i => i.classList.remove('active'));
		const icon = section.querySelector(`.icon-container[data-location-id="${locationId}"]`);
		if (icon) icon.classList.add('active');

		const firstSpace = locationEl.querySelector('.space');
		if (firstSpace) activateSpace(firstSpace, locationId);
	}

	// Set initial active states
	const firstLocation = section.querySelector('.location');
	if (firstLocation) activateLocation(firstLocation);

	// Location heading clicks
	section.querySelectorAll('.location-heading').forEach(heading => {
		heading.addEventListener('click', () => {
			activateLocation(heading.closest('.location'));
		});
	});

	// Space heading clicks
	section.querySelectorAll('.space-heading').forEach(heading => {
		heading.addEventListener('click', () => {
			const spaceEl = heading.closest('.space');
			const locationId = spaceEl.closest('.location').dataset.locationId;
			activateSpace(spaceEl, locationId);
		});
	});


	function setGalleryLayout(galleryEl) {
		const images = [...galleryEl.querySelectorAll('.img-container')].slice(0, 6);
		const shapes = images.map(img => img.dataset.shape);
		const count = images.length;
		let layout;

		if (count === 1) {
			layout = 'layout-1';
		} else if (count === 2) {
			layout = shapes.every(s => s === 'tall') ? 'layout-2-cols' : 'layout-2-rows';
		} else if (count === 3) {
			layout = shapes[0] === 'tall' ? 'layout-3-left' : 'layout-3-top';
		} else if (count === 4) {
			layout = 'layout-4';
		} else if (count === 5) {
			layout = shapes[0] === 'tall' ? 'layout-5-tall-first' : 'layout-5-wide-first';
		} else {
			layout = 'layout-6';
		}

		galleryEl.dataset.layout = layout;
	}

	section.querySelectorAll('.space-gallery').forEach(setGalleryLayout);

	const startLocationSwipers = () => {
		section.querySelectorAll('.space-swiper').forEach(el => {
			new Swiper(el, {
				slidesPerView: 1,
				spaceBetween: 20,
				pagination: {
					el: el.querySelector('.space-swiper-pagination'),
                    clickable: true
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
					},
				}
			});
		});
	};

	startLocationSwipers();
});
